import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ConstructionIcon from '@mui/icons-material/Construction';

export default function EmDesenvolvimento({ previsao }) {
  const navigate = useNavigate();
  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', py: 10, px: 3,
    }}>
      <Box sx={{
        width: 72, height: 72, borderRadius: '50%', mb: 3,
        backgroundColor: '#eef0f3', display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <ConstructionIcon sx={{ fontSize: 32, color: '#94a3b8' }} />
      </Box>
      <Typography variant="h6" fontWeight={700} sx={{ color: '#1a1a2e', mb: 1 }}>
        Em desenvolvimento
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380, mb: previsao ? 0.5 : 3 }}>
        Esta área ainda está sendo preparada para uso e será liberada em breve.
      </Typography>
      {previsao && (
        <Typography variant="body2" sx={{ color: '#13375F', fontWeight: 600, mb: 3 }}>
          Previsão: {previsao}
        </Typography>
      )}
      <Button variant="contained" onClick={() => navigate('/')} sx={{ backgroundColor: '#13375F' }}>
        Voltar ao início
      </Button>
    </Box>
  );
}